import { DetalleTransporte } from "../../../services/transporteServicios";

export type ModificacionesHoja = {
  id: string;
  modificacionesPorIdEntrada?: Map<string, ModificacionesDetalle>;
  modificacionesPorIdSalida?: Map<string, ModificacionesDetalle>;
};

export type ModificacionesDetalle = {
  detalle: DetalleTransporte;
  orden?: number;
  transportado?: boolean;
};

export const ordenarDetalles = <D extends DetalleTransporte>(
  detalles: D[],
  modificacionesDetalles: Map<string, ModificacionesDetalle> | undefined
): D[] => {
  if (!detalles) return [];

  let entradasOrdenadas = detalles;
  entradasOrdenadas.sort((itemA: D, itemB: D) => {
    const ordenModA = modificacionesDetalles?.get(itemA.id)?.orden;
    const ordenA = ordenModA ? ordenModA : itemA.orden;

    const ordenModB = modificacionesDetalles?.get(itemB.id)?.orden;
    const ordenB = ordenModB ? ordenModB : itemB.orden;
    return ordenA - ordenB;
  });

  return entradasOrdenadas;
};
